export default {"src":"/_next/static/media/overige.a2df2927.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};